import { z } from "zod";
export const predictiveMaintenanceInsightDtoSchema = z.object({
    id: z.string(),
    criticality: z.enum(["medium", "high"]),
    useCase: z.string(),
    description: z.string(),
    generatedAtUtc: z.string(),
    deviceSerialNumber: z.string(),
    customerNumber: z.string(),
    serviceAreaId: z.string(),
    lelyCenterNumber: z.string(),
    deviceType: z.string().nullable(),
    customerName: z.string().nullable(),
    lelyCenterName: z.string().nullable(),
});
//# sourceMappingURL=predictive-maintenance.schema.js.map